exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GlIK{background-color:rgba(22,45,61,.6)}.KDjSu{padding:0}.SvFMd{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;padding:40px 30px 30px}._1-T-Q{margin-bottom:30px}.X479Z{-ms-flex-item-align:end;align-self:flex-end;height:30px;padding:0 30px}", ""]);

// exports
exports.locals = {
	"modal": "_1GlIK",
	"modal-content": "KDjSu",
	"modalContent": "KDjSu",
	"prompt-wrapper": "SvFMd",
	"promptWrapper": "SvFMd",
	"second-message": "_1-T-Q",
	"secondMessage": "_1-T-Q",
	"close-button": "X479Z",
	"closeButton": "X479Z"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/components/preview-prompt/preview-prompt.styl
// module id = 1406
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact